<template>
  <div class="product-cart slide-holder">
    <div
      class="row"
      :class="{
        'text-left': $i18n.locale === 'en',
        'text-right': $i18n.locale === 'ar',
      }"
    >
      <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12">
        <div class="time-holder" v-if="hasImage">
          <b-img :src="slider.image_path" class="offer-image w-100"></b-img>
          <div class="time-count" v-if="dealType">{{ dealType }}</div>
        </div>
      </div>
      <div
        class="col-xl-6 col-lg-12 col-md-12 col-sm-12 d-flex flex-column align-items-start justify-content-between"
      >
        <div v-if="slider">
          <div class="card-info">
            <h4 class="main-header my-2" v-if="hasTitle">
              <router-link
                :to="{ path: '/basketOfferDetails', query: { id: slider.id } }"
              >
                {{ displayTitle }}
              </router-link>
            </h4>
            <h5 class="price m-0" v-if="hasBasketPrice">
              {{ slider.currency_based_basket_price | fixedCurrency }}
              {{ currency }}
            </h5>
            <p class="price-after price m-0" v-if="hasDiscountPrice">
              {{ slider.currency_based_price_before_discount | fixedCurrency }}
              {{ currency }}
            </p>
          </div>
        </div>
        <div
          class="row mb-3 align-items-center w-100"
          :class="{ 'flex-column w-100': !add_to_cart }"
        >
          <div class="col-12 px-1">
            <router-link
              :to="{ path: '/basketOfferDetails', query: { id: slider.id } }"
              v-if="slider"
            >
              <button class="outline-main">{{ $t("profile.details") }}</button>
            </router-link>
          </div>
          <button v-if="isVisitWebsite" class="mx-2 border-main">
            <a :href="slider.conference_register_link" target="_blank">
              <h5 class="p-2 m-0">{{ $t("login.visitWebsite") }}</h5>
            </a>
          </button>
          <div v-else>
            <div class="col-12 px-1" v-if="isInStockAndAddToCart">
              <a>
                <button class="bg-main text-white" @click="addToCart(slider)">
                  {{ $t("items.addToCart") }}
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      class="border-main main-color br-5 btn btn-block mt-2"
      v-if="buttonTrue"
      @click="getOffer(slider)"
    >
      {{ $t("singleProduct.getOffer") }}
    </button>
  </div>
</template>

<script>
import globalAxios from "@/services/global-axios";
import suppliers from "@/services/suppliers";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

export default {
  name: "BasketCard",
  props: {
    slider: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    dealType: {
      type: String,
      default: null,
    },
    buttonTrue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cartCounter: 1,
      requestData: {
        name: null,
        request_qty: null,
        comment: null,
      },
      errors: [],
      supplierProductId: null,
      selected: 1,
    };
  },
  computed: {
    hasImage() {
      return this.slider && this.slider.image_path !== null;
    },
    hasTitle() {
      return (
        (this.slider && this.slider.title && this.dealType) ||
        (this.slider &&
          this.slider.product &&
          this.slider.product.title &&
          !this.dealType)
      );
    },
    displayTitle() {
      return this.dealType
        ? this.slider.title
        : (this.slider.product && this.slider.product.title) || "";
    },
    hasBasketPrice() {
      return (
        this.slider &&
        typeof this.slider.currency_based_basket_price === "number"
      );
    },
    hasDiscountPrice() {
      return (
        this.slider &&
        typeof this.slider.currency_based_price_before_discount === "number" &&
        this.slider.currency_based_price_before_discount >
          this.slider.currency_based_basket_price
      );
    },
    isVisitWebsite() {
      return (
        this.slider &&
        this.slider.product_details_by_type &&
        this.slider.product_details_by_type.add_type === "visit_website"
      );
    },
    isInStockAndAddToCart() {
      return (
        this.slider &&
        this.slider.in_stock === true &&
        this.add_to_cart === true
      );
    },
  },
  methods: {
    addToCart(myProduct) {
      const data = {
        basket_promotion_id: myProduct.id,
        quantity: this.selected > 0 ? this.selected : 1,
      };
      return globalAxios
        .post(`cart/add`, data)
        .then((res) => {
          if (res.status === 200) {
            this.$swal({
              title: this.$t("success"),
              text: res.data.message,
              icon: "success",
            });
            this.$modal.show(
              () => import("@/components/cart/cartModal.vue"),
              { product: myProduct },
              { width: "700", height: "auto", adaptive: true }
            );
          }
        })
        .catch((error) => {
          const err =
            error.response && error.response.data ? error.response.data : {};
          this.errors = err.items || [];
          this.$swal({
            title: this.$t("error"),
            text: err.message || this.$t("errorOccurred"),
            icon: "error",
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.$store.dispatch("cart/getCartProducts");
          }, 500);
        });
    },
    requestQuotation() {
      const payload = {
        qoute_name: this.requestData.name,
        product_supplier_id: this.supplierProductId,
        request_qty: this.requestData.request_qty,
        comment: this.requestData.comment,
      };
      suppliers
        .requestQuotation(payload)
        .then((resp) => {
          this.errors = {};
          this.$swal({
            title: this.$t("success"),
            text: resp.data.message,
            icon: "success",
          });
          setTimeout(() => {
            document.querySelector(".close").click();
            this.requestData = { name: null, request_qty: null, comment: null };
          }, 500);
          setTimeout(() => {
            this.$router.push({
              name: "QuotationDetails",
              params: { id: resp.data.items.client_quote_id },
            });
          }, 1000);
        })
        .catch((error) => {
          const err =
            error.response && error.response.data ? error.response.data : {};
          this.errors = err.items || [];
          this.$swal({
            title: this.$t("error"),
            text: err.message || this.$t("errorOccurred"),
            icon: "error",
          });
        });
    },
    storeProductSupplierId(product_supplier_id) {
      this.supplierProductId = product_supplier_id;
    },
    loginFirst() {
      this.$swal({
        title: this.$t("singleProduct.loginFirst"),
        text: this.$t("singleProduct.registerNow"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("register"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push("/user-register");
        }
      });
    },
    getOffer(slider) {
      this.$router.push({
        path: "/basketOfferDetails",
        query: { id: slider.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/**
    * component style 
  */
.product-cart {
  padding: 0;
  margin: 0 10px;
  text-align: center;
  display: inline-block;
  position: relative;
  overflow: hidden;
  min-width: 250px;
  overflow: hidden;
  a {
    display: inline-block;
    opacity: 1;

    border-radius: 50%;
    width: 95%;
    @media (max-width: 992px) {
      width: 100%;
    }
    &:hover {
      opacity: 0.5;
    }
    img {
      min-width: 250px;
      height: 150px;
      border-radius: 0%;
      display: block;
      object-fit: cover;
    }
    button {
      width: 100%;
      margin: 5px 0;
    }
  }
  .card-info {
    margin: auto;
    margin-bottom: 10px;
    text-align: start;
    min-height: 100px;
    h4 {
      a {
        opacity: 1;
        color: #312620;
        font-size: 18px;
        &:hover {
          color: #2b96cc;
        }
      }
    }
  }
  .null-img-holder {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    display: block;
  }
}
.product-silder button:not(:disabled) {
  display: block !important;
}
button.new {
  background: $main-color;
}
.rfqBtn {
  background: #000;
}

.offer-image {
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 10px;
}

.slide-holder {
  background-color: #eff0f0;
  border-radius: 10px;
  padding: 15px;
  width: 95% !important;
}
@media (max-width: 992px) {
  .slide-holder {
    width: 100% !important;
  }
}

button {
  border-radius: 8px;
  padding: 10px 20px;
  border: none;
  box-shadow: none;
  outline: none;
}

.outline-main {
  border: 2px solid $main-color;
  background: transparent;
  color: $main-color;
}

.supplier-name {
  text-decoration: underline !important;
  color: inherit;
}

.time-holder {
  position: relative;
  text-align: center;
  padding: 0 5px;
}

.time-count {
  position: absolute;
  top: 0;
  left: 10px;
  font-size: 14px;
  background: $main-color;
  border-radius: 0 0 20px 20px;
  color: #fff;
  right: 10px;
  padding: 0 5px;
}

.row {
  @media (max-width: 1200px) {
    justify-content: center !important;
    align-items: center !important;
    text-align: center !important;
  }
}
</style>
